
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core'
import { IUserState, userFacadeBase } from './user.state';
import { User } from './user.model';
import { UserService } from './user.service';
import { Observable } from 'rxjs';
import { getAuthData } from '../auth/store/auth.selectors';
import { first, map, switchMap, tap } from 'rxjs/operators';
import { AuthData } from '../auth/auth-data.model';

@Injectable()
export class UserFacade extends userFacadeBase {

    currentUser$: Observable<User>;

    constructor(private store: Store<IUserState>, private userService: UserService, private storeAuthData: Store<AuthData>) {
        super(User, store);
        this.getCurrentUser$();
    }

    updatePassword(username: string, password: string): Observable<User> {
        return this.userService.updatePassword(username, password);
    }

    updateProfile(user: User): Observable<User> {
        return this.userService.updateProfile(user);
    }

    getCurrentUser$() {

        this.currentUser$ = this.storeAuthData.select(getAuthData).pipe(
            map(authData => authData.userId),
            tap(id => {
                this.selectByKey(id);
                this.hasUser(id).pipe(first()).subscribe(exists => {
                    if (!exists) {
                        this.load(id);
                    }
                });
            }),
            switchMap(() => this.current$)

        );
    }

    getCurrentUser():Observable<User> {

        return this.storeAuthData.select(getAuthData).pipe(
            map(authData => authData.userId),
            tap(id => {
                this.selectByKey(id);
                this.hasEntities$.pipe(first()).subscribe(exists => {
                    if (!exists) {
                        this.load(id);
                    }
                });
            }),
            switchMap(() => this.current$)

        );
    }

    hasUser(id: number): Observable<boolean> {
        return this.ids$.pipe(
            map((ids: number[]) => ids.indexOf(id) > -1)
        );
    }
    getEnabledUsers(): Observable<User[]> {
        return this.userService.getEnabledUsers();
    }

    getUsersByRole(roleId: number): Observable<User[]> {
        return this.userService.getUsersByRole(roleId);
    }

}